import Compressor from 'compressorjs';

export const normalizeImage = async (image) =>
  new Promise((resolve) => {
    const compressor = (file) =>
      new Compressor(file, {
        quality: 0.9,
        // on the backend images are scaled to 1080px (max value of width or height)
        // to reduce the amount of data transmitted over the network
        // the same scaling rules are applied here before submitting the image
        maxWidth: 1080,
        maxHeight: 1080,
        success(resultFile) {
          let normalizedFile = resultFile;
          if (normalizedFile instanceof Blob) {
            normalizedFile = new File([resultFile], resultFile.name, {
              type: resultFile.type,
            });
          }
          if (normalizedFile instanceof File) {
            resolve(normalizedFile);
          } else {
            // return the original file if by some reason
            // the instance of the processed image is not File
            resolve(file);
          }
        },
        error() {
          // return the original file in case of an error
          resolve(file);
        },
      });

    compressor(image);
  });
